module.exports = __webpack_public_path__ + "static/media/words2.08fc10ee.png";